"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DMSError {
    constructor(code, description) {
        this.code = code;
        this.description = description;
    }
}
exports.default = DMSError;
//# sourceMappingURL=DMSError.js.map